var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsString, IsUUID } from 'class-validator';
import { PreventionEvaluationResponseFullSizeDto } from './prevention-evaluation-response.full-size.dto.js';
export class PreventionEvaluationResponseSetFullSizeDto {
    id;
    createdAt;
    updatedAt;
    notes;
    preventionEvaluationResponses;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionEvaluationResponseSetFullSizeDto.prototype, "id", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], PreventionEvaluationResponseSetFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    Exclude(),
    IsDateString(),
    __metadata("design:type", Date)
], PreventionEvaluationResponseSetFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], PreventionEvaluationResponseSetFullSizeDto.prototype, "notes", void 0);
__decorate([
    IsArray(),
    Type(() => PreventionEvaluationResponseFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], PreventionEvaluationResponseSetFullSizeDto.prototype, "preventionEvaluationResponses", void 0);
//# sourceMappingURL=prevention-evaluation-response-set.full-size.dto.js.map